import React from "react";
import PropTypes from "prop-types";
import UIButton from "../UIButton";

const UIActionModalActions = ({
  cancelLabel,
  confirmLabel,
  onCancel,
  onConfirm,
  confirmDisabled,
  confirmVariant,
}) => (
  <div className="ui-modal__actions ui-action-modal__actions">
    <UIButton variant="outline" size="medium" fullWidth onClick={onCancel}>
      {cancelLabel}
    </UIButton>
    <UIButton
      appearance={confirmVariant === "approve" ? "gradient" : "default"}
      color={confirmVariant === "reject" ? "error" : "primary"}
      size="medium"
      fullWidth
      disabled={confirmDisabled}
      onClick={onConfirm}
    >
      {confirmLabel}
    </UIButton>
  </div>
);

export default UIActionModalActions;

UIActionModalActions.propTypes = {
  cancelLabel: PropTypes.node.isRequired,
  confirmLabel: PropTypes.node.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  confirmDisabled: PropTypes.bool,
  confirmVariant: PropTypes.oneOf(["approve", "reject"]),
};

UIActionModalActions.defaultProps = {
  confirmDisabled: false,
  confirmVariant: "approve",
};